// constants
import { getOptimisedImageUrl, imageHostRegExp } from 'shared/helpers/utils';

export const getSrcSet = (src: string, width: number) => {
  // check if image optimisations are supported
  if (imageHostRegExp.test(src) === false) {
    return '';
  }

  const optimisedSrc1x = getOptimisedImageUrl(src, { width });
  const optimisedSrc2x = getOptimisedImageUrl(src, { width: width * 2 });

  return `${optimisedSrc1x} 1x, ${optimisedSrc2x} 2x, ${src} 3x`;
};
